import AcceptInvitation from './acceptInvitation';
import { AnonymousAssetById } from './anonymousAssetById';
import { Invitation } from './invitation';

export const anonymousRoutes = [
  { path: '/anonymous/assets/:assetId', element: <AnonymousAssetById /> },
  { path: '/invitation/:invitationId/:workspaceId', element: <Invitation /> },
  {
    path: '/acceptInvitation/:invitationId/:workspaceId',
    element: <AcceptInvitation />,
  },
];
